"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.then = void 0;
var then = function (f, g) { return function (x) { return g(f(x)); }; };
exports.then = then;
